import { IconChevronUp, IconDevices, IconHeadset } from "@tabler/icons-react";
import type { TopLinksRowItem } from "@/components/layout/header/TopLinksRow";
import {
  SERVICE_CATALOG,
  type ServiceCatalogItem,
} from "@/utils/constants/services/serviceCatalog";
import { SidebarItem } from "@/components/layout/layout.type";
import type {
  FooterIconLinkItem,
  FooterLinkItem,
  FooterPaymentItem,
  FooterStoreLinkItem,
} from "@/components/layout/footer/footerItems";

// Floating Action Id
export type FloatingActionId = "back-to-top" | "download-app" | "support";

// Floating Action Item
export type FloatingActionItem = {
  id: FloatingActionId;
  label: string;
  icon: typeof IconChevronUp;
};

// Floating Actions
export const floatingActions: FloatingActionItem[] = [
  { id: "back-to-top", label: "Back to top", icon: IconChevronUp },
  { id: "download-app", label: "Download App", icon: IconDevices },
  { id: "support", label: "Support", icon: IconHeadset },
];

// Sidebar Items
export const sidebarItems: SidebarItem[] = [
  ...SERVICE_CATALOG.filter((service) => service.sidebarTablerIcon).map(
    (service) => ({
      label: (service as ServiceCatalogItem).sidebarLabel ?? service.label,
      href: service.routePath,
      integrationKey: service.integrationKey,
      matchPaths: service.matchPaths,
      tablerIcon: service.sidebarTablerIcon!,
    }),
  ),
  {
    label: "Discovery",
    href: "/discovery",
    tablerIcon: "discovery",
    disableAutoActive: true,
  },
  // {
  //   label: "Ticket & Coupon",
  //   href: "/vouchers",
  //   matchPaths: ["/ticket-coupon", "/voucher", "/vouchers"],
  //   tablerIcon: "ticketCoupon",
  // },
  // {
  //   label: "Invite and Earn",
  //   href: "/invite-and-earn",
  //   tablerIcon: "invite",
  //   showSeparatorAfter: true,
  // },
  {
    label: "Become a Partner",
    href: "/partner",
    tablerIcon: "partner",
  },
  // {
  //   label: "About TovTrip",
  //   href: "/about",
  //   tablerIcon: "about",
  // },
];

export const footerSectionsConfig: Array<{
  title: string;
  items: FooterLinkItem[];
}> = [
  {
    title: "Company | ក្រុមហ៊ុន",
    items: [
      // { label: "About Tovtrip", href: "/about" },
      {
        label: "Careers | ឱកាសការងារ",
        href: "https://www.facebook.com/tovtripcambodia",
      },
      { label: "Partner with Us | ចូលរួមជាដៃគូអាជីវកម្ម", href: "/partner" },
      {
        label: "Company Profile | ព័ត៌មាន",
        href: "https://d22aqk4iplyqyv.cloudfront.net/tovtrip/Company+profile_general+profile+2026.pdf",
        icon: "arrow-up-right",
        underline: true,
      },
    ],
  },
  {
    title: "Support | ជំនួយ",
    items: [
      { label: "Help Center | មជ្ឈមណ្ឌលជំនួយ", action: "support_dialog" },
      {
        label: "Terms & Conditions | លក្ខខណ្ឌប្រើប្រាស់",
        href: "/term-and-condition",
      },
      { label: "Privacy Policy | គោលការណ៍", href: "/privacy-policy" },
    ],
  },
];

// Social Links
export const socialLinks: FooterIconLinkItem[] = [
  {
    src: "/social/fb.svg",
    alt: "Facebook",
    href: "https://www.facebook.com/tovtripcambodia",
  },
  {
    src: "/social/ig.svg",
    alt: "Instagram",
    href: "https://www.instagram.com/tovtrip",
  },
  {
    src: "/social/tiktok.svg",
    alt: "TikTok",
    href: "https://www.tiktok.com/@tovtrip.kh?is_from_webapp=1&sender_device=pc",
  },
  {
    src: "/social/telegram.svg",
    alt: "Telegram",
    href: "https://t.me/tovtrip",
  },
  {
    src: "/social/linkedin.svg",
    alt: "LinkedIn",
    href: "https://www.linkedin.com/company/tovtrip-kh/posts/?feedView=all",
  },
];

// Payment Methods
export const paymentMethods: FooterPaymentItem[] = [
  { src: "/payments/khqr.svg", alt: "KHQR" },
  { src: "/payments/visa.svg", alt: "Visa" },
  { src: "/payments/mastercard.svg", alt: "Mastercard" },
  { src: "/payments/jcb.svg", alt: "Jcb" },
  { src: "/payments/unionpay.svg", alt: "UnionPay" },
];

export const partnerMethods: FooterPaymentItem[] = [
  { src: "/footer/aba.svg", alt: "ABA" },
  { src: "/footer/wing.svg", alt: "WING" },
  { src: "/footer/bookmyfly.svg", alt: "Book me fly" },
  { src: "/footer/smart.svg", alt: "Smart" },
  // { src: "/footer/knowroaming.svg", alt: "KnowRoaming" },
];

export const membershipAffiliationItems: FooterPaymentItem[] = [
  { src: "/footer/cata.svg", alt: "CATA" },
  { src: "/footer/ccc.svg", alt: "CCC" },
  { src: "/footer/der_leng.svg", alt: "Der Leng" },
];

// App Store Links
export const appStoreLinks: FooterStoreLinkItem[] = [
  {
    href: "https://play.google.com/store/apps/details?id=com.tovtrip.v2app",
    icon: "/store/playstore.svg",
    label: "Google Play",
    iconWidth: 22,
    iconHeight: 24,
  },
  {
    href: "https://apps.apple.com/kh/app/tovtrip-travel-superapp/id6737310675",
    icon: "/store/apple.svg",
    label: "App Store",
    iconWidth: 24,
    iconHeight: 24,
  },
];

export const legalPageNavItems: Array<TopLinksRowItem> = [
  { href: "/term-and-condition", label: "Terms & Conditions" },
  { href: "/privacy-policy", label: "Privacy Policy" },
];
